import { Link } from "react-router-dom";
import { positions } from "../../../utils/PositionStateData";

const SpotRegisterAthleteStep1 = ({
  register,
  errors,
  shouldShowError,
  watch,
  eventNameSelected,
  onNext,
  loading,
}) => {
  const primaryPositions = positions.filter((p) => p !== "None");
  const selectedPosition = watch("primaryPosition");

  return (
    <>
      {/* Info area */}
      <div className="alert flex flex-row items-center bg-red-200 p-3 rounded border-b-2 border-red-300 mt-3 hidden">
        <div className="alert-icon flex items-center bg-red-100 border-2 border-red-500 justify-center h-8 w-8 flex-shrink-0 rounded-full">
          <span className="text-red-500">
            <svg fill="currentColor" viewBox="0 0 20 20" className="h-6 w-6">
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              ></path>
            </svg>
          </span>
        </div>
        <div className="alert-content ml-4">
          <div className="alert-title font-semibold text-sm text-red-700">
            Step 1 Register for the Portal Combine
          </div>
          <div className="alert-description text-xs text-red-500">
            Fill out the form below to register for the January event.
          </div>
          <div className="alert-description text-xs text-red-500">&nbsp;</div>
          <div className="alert-title font-semibold text-sm text-red-700">
            Step 2 Claim your FLX ID
          </div>
          <div className="alert-description text-xs text-red-500">
            This is your ticket to the Portal Combine. <br></br>
            After registration, you'll see a link to start, or complete your FLX
            ID. <br></br>
            [For identify verification and security, some of the questions will
            be the same]<br></br>
            At the Combine, you will receive a digital FLX Link to wear as a
            wristband, containing all your FLX ID information. After the event,
            it will be updated with all new mesaurables from the Portal Combine.
          </div>
        </div>
      </div>
      <div className="text-[#06D1E8] py-4 text-2xl font-bold my-3 pt-4">
        {eventNameSelected} Combine Registration
      </div>

      {/* Info area */}

      <div
        className="alert flex flex-row items-center bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3 my-4 rounded-md"
        role="alert"
      >
        <div className="alert-icon flex items-center bg-blue-100 border-2 border-blue-500 justify-center h-7 w-7 flex-shrink-0 rounded-full">
          <span className="text-blue-500">
            <svg fill="currentColor" viewBox="0 0 20 20" className="h-5 w-5">
              5
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              ></path>
            </svg>
          </span>
        </div>
        <div className="alert-content ml-4 w-full">
          <div className="alert-title font-semibold text-lg text-blue-700">
            Already registered for a previous combine?
          </div>
          <div className="alert-description text-sm text-blue-700">
            Please
            <Link
              className="text-blue-700 font-semibold hover:underline px-1"
              to="/sign-in"
            >
              Sign In
            </Link>
            to your account, select this event from your dashboard and click
            Register.
          </div>
          <div className="alert-title font-semibold text-base text-blue-700 mt-3 pt-1 border-t border-blue-300">
            Event details will be sent after registration.
          </div>
        </div>
      </div>

      <h2 className="text-lg font-bold mb-2 text-white border-b pb-2 border-gray-700">
        Personal Details
      </h2>
      <div className="grid sm:grid-cols-2 gap-x-6">
        <div className="form-field mt-4">
          <label htmlFor="firstName">First Name</label>
          <input
            {...register("firstName", {
              required: "First name is required",
            })}
            placeholder="Enter your first name"
          />

          {shouldShowError("firstName") && errors.firstName && (
            <span className="text-red-500 text-sm">
              {errors.firstName?.message}
            </span>
          )}
        </div>
        <div className="form-field mt-4">
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            {...register("lastName", {
              required: "Last name is required",
            })}
            placeholder="Enter your last name"
          />

          {shouldShowError("lastName") && errors.lastName && (
            <span className="text-red-500 text-sm">
              {errors.lastName?.message}
            </span>
          )}
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-1 xl:gap-8 lg:gap-8 mt-4">
        <div className="form-field mt-0">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            {...register("email", {
              required: "Email is required",

              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,

                message: "Invalid email address",
              },
            })}
            placeholder="Enter your email"
          />

          {shouldShowError("email") && errors.email && (
            <span className="text-red-500 text-sm">
              {errors.email?.message}
            </span>
          )}
        </div>
        <div className="form-field mt-0">
          <label htmlFor="confirmEmail">Confirm Email</label>
          <input
            type="email"
            {...register("confirmEmail", {
              required: "Please confirm your email",
              validate: (value, formValues) =>
                value === formValues.email || "Email addresses do not match",
            })}
            placeholder="Re-enter your email"
          />
          {shouldShowError("confirmEmail") && errors.confirmEmail && (
            <span className="text-red-500 text-sm">
              {errors.confirmEmail?.message}
            </span>
          )}
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-1 xl:gap-8 lg:gap-8 mt-4">
        <div className="form-field mt-0">
          <label htmlFor="Password">Password</label>
          <input
            type="password"
            aria-invalid={errors.password ? "true" : "false"}
            name="password"
            {...register("password", {
              required: "Password is required",
            })}
            placeholder="Enter password"
          />

          {shouldShowError("password") && errors.password && (
            <span className="text-red-500 text-sm">
              {errors.password?.message}
            </span>
          )}
        </div>
        <div className="form-field mt-0">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            type="password"
            {...register("confirmPassword", {
              required: "Please confirm your password",
              validate: (value, formValues) =>
                value === formValues.password || "Passwords do not match",
            })}
            placeholder="Re-enter your password"
          />
          {shouldShowError("confirmPassword") && errors.confirmPassword && (
            <span className="text-red-500 text-sm">
              {errors.confirmPassword?.message}
            </span>
          )}
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-x-6 mt-4">
        <div className="form-field mt-0">
          <label htmlFor="athletePhoneNumber">Athlete Phone Number</label>
          <input
            type="tel"
            id="athletePhoneNumber"
            inputMode="numeric"
            pattern="[0-9]{10}"
            placeholder="Enter athlete's phone number"
            maxLength={10}
            {...register("athletePhoneNumber", {
              required: "Athlete Phone Number is required",

              pattern: {
                value: /^[0-9]{10}$/,

                message: "Enter a valid 10-digit phone number",
              },
            })}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
            }}
          />

          {shouldShowError("athletePhoneNumber") &&
            errors.athletePhoneNumber && (
              <span className="text-red-500 text-sm">
                {errors.athletePhoneNumber?.message}
              </span>
            )}
        </div>
        <div className="form-field mt-0">
          <label htmlFor="parentPhoneNumber">Parent Phone Number</label>
          <input
            type="tel"
            id="parentPhoneNumber"
            inputMode="numeric"
            pattern="[0-9]{10}"
            placeholder="Enter parent phone number (optional)"
            maxLength={10}
            {...register("parentPhoneNumber", {
              pattern: {
                value: /^[0-9]{10}$/,

                message: "Enter a valid 10-digit phone number",
              },
            })}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
            }}
          />

          {shouldShowError("parentPhoneNumber") && errors.parentPhoneNumber && (
            <span className="text-red-500 text-sm">
              {errors.parentPhoneNumber?.message}
            </span>
          )}
        </div>
      </div>

      {/* Athletic Information*/}
      <div className="mt-8">
        <h2 className="text-lg font-bold mb-4 text-white border-b pb-2 border-gray-700 ">
          Athletic Information
        </h2>
        <div className="grid sm:grid-cols-2 gap-1 xl:gap-8 lg:gap-8 mt-4">
          <div className="form-field mt-0 relative">
            <label
              htmlFor="primaryPosition"
              className="block text-base text-gray-900 dark:text-white"
            >
              Primary Position
            </label>
            <select
              id="primaryPosition"
              {...register("primaryPosition", {
                required: "Primary Position is required",
              })}
              className={`bg-gray-50 border border-gray-300 text-md rounded-md w-full pr-10 appearance-none bg-no-repeat ${
                selectedPosition ? "text-gray-900" : "text-gray-400"
              }`}
              style={{
                backgroundImage:
                  "url(\"data:image/svg+xml,%3Csvg fill='none' stroke='%236b7280' stroke-width='4' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E\")",

                backgroundPosition: "right 0.75rem center",

                backgroundSize: "1.1rem",

                backgroundRepeat: "no-repeat",
              }}
            >
              <option value="" disabled className="text-white bg-gray-800">
                Select primary position
              </option>

              {primaryPositions.map((position) => (
                <option
                  key={position}
                  value={position}
                  className="text-white bg-gray-800"
                >
                  {position === "Interior Offensive Line"
                    ? "Interior Offensive Line (Guard or Center)"
                    : position}
                </option>
              ))}
            </select>

            {shouldShowError("primaryPosition") && errors.primaryPosition && (
              <span className="text-red-500 text-sm">
                {errors.primaryPosition.message}
              </span>
            )}
          </div>
          <div className="form-field mt-0">
            <label htmlFor="expectedYearOfGraduation">
              High School Graduation Year
            </label>

            <input
              type="text"
              inputMode="numeric"
              maxLength={4}
              className="no-spinner"
              name="expectedYearOfGraduation"
              {...register("expectedYearOfGraduation", {
                pattern: {
                  value: /^[0-9]{4}$/,
                  message: "Please enter a valid 4-digit graduation year",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 4);
              }}
              placeholder="Enter graduation year"
            />

            {shouldShowError("expectedYearOfGraduation") &&
              errors.expectedYearOfGraduation && (
                <span className="text-red-500 text-sm">
                  {errors.expectedYearOfGraduation?.message}
                </span>
              )}
          </div>
        </div>
      </div>

      <div className="px-2 my-10">
        <button
          type="button"
          onClick={onNext}
          disabled={loading}
          className="bg-red-500 text-white uppercase rounded-full px-8 py-3 text-center mt-4 hover:bg-red-700 cursor-pointer w-full disabled:opacity-50"
        >
          Continue
        </button>
      </div>
    </>
  );
};

export default SpotRegisterAthleteStep1;
